import React, { useState, useEffect, useRef } from 'react';
import SaleDisplay from './components/SaleDisplay';
import './App.css';

const safeParse = (json) => {
  try {
    return JSON.parse(json);
  } catch (err) {
    console.warn('[CFD] Failed to parse payload', err);
    return null;
  }
};

function App() {
  const [saleData, setSaleData] = useState(null);
  const [storeInfo, setStoreInfo] = useState(null);
  const lastRevisionRef = useRef(0);

  useEffect(() => {
    const shouldAcceptRevision = (message) => {
      const rawRevision = message.revision ?? message.sale?.revision;
      if (rawRevision == null) return true;
      const revision = Number(rawRevision);
      if (!Number.isFinite(revision)) return true;
      if (revision < lastRevisionRef.current) return false;
      lastRevisionRef.current = revision;
      return true;
    };

    const handleEnvelope = (raw) => {
      if (!raw) return;
      const message = typeof raw === 'string' ? safeParse(raw) : raw;
      if (!message || typeof message !== 'object') return;
      if (!shouldAcceptRevision(message)) return;

      switch (message.type) {
        case 'saleUpdate':
          setSaleData(message.sale || null);
          setStoreInfo(message.store || null);
          break;
        case 'idle':
          setSaleData(null);
          setStoreInfo(message.store || null);
          break;
        case 'clear':
        default:
          setSaleData(null);
          break;
      }
    };

    const api = {
      receive: handleEnvelope,
      updateCart: (payload) => handleEnvelope({ type: 'saleUpdate', ...payload }),
      clear: () => handleEnvelope({ type: 'clear' }),
    };

    window.CustomerDisplay = api;
    if (window.CustomerDisplayReady) {
      window.CustomerDisplayReady();
    }
    if (window.__pendingCustomerDisplayPayload) {
      handleEnvelope(window.__pendingCustomerDisplayPayload);
      window.__pendingCustomerDisplayPayload = null;
    }

    return () => {
      window.CustomerDisplay = null;
    };
  }, []);


  return (
    <div className="container">
      <SaleDisplay saleData={saleData} storeInfo={storeInfo} />
    </div>
  );
}

export default App;
